import { useState } from "react";

/* ================= ESTIMATE PRICE CARD ================= */
function EstimateCard({ product, fabric, units, printMethod, printSize }) {
  const unlocked = product && fabric && units && printMethod && printSize;

  const basePrice = 200;
  const fabricCost = fabric ? 50 : 0;
  const printCost = printMethod ? 40 : 0;
  const qty = units ? Number(units) : 0;

  const price = (basePrice + fabricCost + printCost) * qty;

  return (
    <div className="bg-[#1E1F26] text-white p-5 rounded relative overflow-hidden">
      <p className="text-lg mb-3">Estimate Price</p>

      <div className="bg-gray-500/40 h-14 flex items-center justify-center rounded text-xl font-semibold tracking-widest">
        ₹ {price || "0.00"}
      </div>

      {!unlocked && (
        <div className="absolute inset-0 backdrop-blur-md bg-white/10 flex items-center justify-center">
          <div className="text-3xl">🔒</div>
        </div>
      )}
    </div>
  );
}

/* ================= MAIN PAGE ================= */
export default function Estimate() {
  const [product, setProduct] = useState("");
  const [fabric, setFabric] = useState("");
  const [units, setUnits] = useState("");
  const [printMethod, setPrintMethod] = useState("");
  const [printSize, setPrintSize] = useState("");

  const productSelected = product !== "";
  const detailsFilled = product && fabric && units && printMethod;

  const products = [
    "T-shirt",
    "Oversized",
    "Polo",
    "Hoodie",
    "Sweatshirt",
    "Varsity",
    "Zipper",
    "Others",
  ];

  return (
    <div className="bg-gray-100 min-h-screen p-8">
      <div className="max-w-6xl mx-auto grid grid-cols-3 gap-6">

        {/* LEFT PANEL */}
        <div className="col-span-2 space-y-6">

          {/* PRODUCT GRID */}
          <div className="bg-white p-4 rounded shadow">
            <p className="text-sm mb-3">Select product :</p>

            <div className="grid grid-cols-4 gap-3">
              {products.map((item) => (
                <div
                  key={item}
                  onClick={() => setProduct(item)}
                  className={`border p-2 cursor-pointer text-center rounded 
                  ${product === item ? "border-black" : "border-gray-300"}`}
                >
                  <div className="h-20 bg-gray-200 mb-2" />
                  <p className="text-xs">{item}</p>
                </div>
              ))}
            </div>
          </div>

          {/* FABRIC + UNITS + PRINT METHOD */}
          {productSelected && (
            <div className="bg-white p-4 rounded shadow space-y-4">

              <div>
                <p className="text-sm mb-2">Choose fabric type :</p>
                <div className="flex gap-2 flex-wrap">
                  {["Cotton", "Dry-fit", "French terry", "Fleece"].map((f) => (
                    <button
                      key={f}
                      onClick={() => setFabric(f)}
                      className={`border px-3 py-1 text-sm rounded
                      ${fabric === f ? "bg-black text-white" : ""}`}
                    >
                      {f}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <p className="text-sm mb-1">Total units required :</p>
                <input
                  type="number"
                  className="border p-2 w-40"
                  onChange={(e) => setUnits(e.target.value)}
                />
              </div>

              <div>
                <p className="text-sm mb-2">Print method :</p>
                <div className="flex gap-2 flex-wrap">
                  {["DTF", "Screen print", "Sublimation", "Embroidery"].map(
                    (m) => (
                      <button
                        key={m}
                        onClick={() => setPrintMethod(m)}
                        className={`border px-3 py-1 text-sm rounded
                        ${printMethod === m ? "bg-black text-white" : ""}`}
                      >
                        {m}
                      </button>
                    )
                  )}
                </div>
              </div>
            </div>
          )}

          {/* PRINT SIZE */}
          {detailsFilled && (
            <div className="bg-white p-4 rounded shadow">
              <p className="text-sm mb-3">
                Select print size (You can select multiple)
              </p>

              <div className="grid grid-cols-4 gap-3">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    onClick={() => setPrintSize(i)}
                    className={`border p-3 cursor-pointer rounded
                    ${printSize === i ? "border-black" : "border-gray-300"}`}
                  >
                    <div className="h-16 bg-gray-200 mb-2" />
                    <p className="text-xs text-center">
                      Print option {i}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* RIGHT PANEL */}
        <div className="space-y-4">
          <EstimateCard
            product={product}
            fabric={fabric}
            units={units}
            printMethod={printMethod}
            printSize={printSize}
          />

          <div className="bg-white p-4 rounded shadow space-y-3">
            <p className="font-semibold text-sm">Contact details</p>

            <input placeholder="Name" className="border p-2 w-full" />
            <input placeholder="Phone number" className="border p-2 w-full" />

            <button className="bg-orange-500 text-white w-full py-2">
              Submit
            </button>

            <button className="border w-full py-2">
              WhatsApp Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
